import React, {useEffect, useRef} from 'react';
import Chart from 'chart.js/auto';

const Chartholder = ({chartData}) => {

	const chartRef = useRef();

	useEffect(() => {

		if (chartData.options.plugins.tooltip) {
			chartData.options.plugins.tooltip.callbacks = {
				label: function(context) {
				  //console.log(context.label)
				  let label = (context.dataset.label)? context.dataset.label:context.label;
				  let value = (context.parsed.y)? context.parsed.y: context.parsed;
				  if (context.dataset.chartType === "barHorz") {
					value = context.parsed.x;
				  }
				  if (context.dataset.isPercent) {
					value = parseFloat(value).toFixed(2) + "%";
				  }
				  if (context.dataset.isDollar) {
					value = "$" + parseFloat(value).toFixed(2);
				  }
				  return label + ": " + value;
				}
			}
		}


		// adds $ to Y axis
		if (chartData.allDataIsDollars) {
			if (chartData.chartType) {
				switch (chartData.chartType) {
					case 'barHorz':
						chartData.options.scales = {
							x: {
								ticks: {
									callback: function(value, index, values) {
										return '$' + value;
									}
								}
							}
						}
						break;
					case 'pie':
						break;
					default:
						chartData.options.scales = {
							y: {
								ticks: {
									callback: function(value, index, values) {
										return '$' + value;
									}
								}
							}
						}
				}
			}

		}
	
		// adds % to Y axis
		if (chartData.allDataIsPercent) {
			if (chartData.chartType) {
				switch (chartData.chartType) {
					case 'barHorz':
						this.chartData.options.scales = {
							x: {
								ticks: {
									callback: function(value, index, values) {
										return value + "%";
									}
								}
							}
						}
						break;
					case 'pie':
						break;
					default:
						chartData.options.scales = {
							y: {
								ticks: {
									callback: function(value, index, values) {
										return value + "%";
									}
								}
							}
						}
				}
			}
		}

		const ctx = chartRef.current.getContext("2d");

		let chartStatus = Chart.getChart("myChart");
		if (chartStatus != undefined) {
			chartStatus.destroy();
		}

		if (!myChart1) {
			var myChart1 = new Chart(ctx, chartData);
		} else {
			myChart1.destroy();
			myChart1 = new Chart(ctx, chartData);
		}
	});


    return (

			<div>
				<canvas
				id="myChart"
                width="600"
                height="350"
				ref={chartRef}
				/>
			</div>
    );
}

export default Chartholder;
